import script from "./ResponsibilityAreas.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResponsibilityAreas.vue?vue&type=script&setup=true&lang=ts"

import "./ResponsibilityAreas.vue?vue&type=style&index=0&id=00b841fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00b841fa"]])

export default __exports__